//pages
import Index from '@/views/pages/authentication/Index.vue'
import Login from '@/views/pages/authentication/Login.vue'
import Register from '@/views/pages/authentication/Register.vue'
import ForgotPassword from '@/views/pages/authentication/ForgotPassword.vue'
import layouts from '@/layout'

export default {
	path: 'authentication',
	name: 'Authentication',
	component: Index,
	redirect: { path: '/register', name: 'register' },
	icon: 'lock',
	children: [
		{
			path: '/login',
			name: 'login',
			component: Login,
			meta: {
				nav: true,
				layout: layouts.contenOnly
			}
		},
		{
			path: '/register',
			name: 'register',
			component: Register,
			meta: {
				nav: true,
				layout: layouts.contenOnly
			}
		},
		{
			path: '/forgot-password',
			name: 'forgot-password',
			component: ForgotPassword,
			meta: {
				nav: true,
				layout: layouts.contenOnly
			}
		}
	]
}
